// extracted by mini-css-extract-plugin
module.exports = {"title":"_3FF-H","open":"YZpYP","collapse":"Kd-zX","link":"jPt7Y","disabled":"eapCv","desktopCol":"_5khkX","scrollRef":"XGMDx","titles":"Hw1ci"};